const recommendation = [
  {
    name: 'Felipe Marzochi',
    message:
      '"Frontend | Backend Andressa é de longe a melhor desenvolvedora auto didata que eu conheço, criativa, inovadora e perfeccionista.."',
    social: 'https://www.linkedin.com/in/felipemarzochi/'
  }
]

export default recommendation
